var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.4904V4.00687C17.5 2.9495 16.41 2.24359 15.4451 2.67614L9.66377 5.26793L5.62346 5.27227C4.81865 5.27312 4.16669 5.92579 4.16669 6.7306V10.8533C4.16669 11.6587 4.8196 12.3116 5.62502 12.3116H9.66377L15.461 14.8281C16.4241 15.2462 17.5 14.5403 17.5 13.4904Z",
    stroke: "#6374FA",
    strokeWidth: 1.04167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 12.3802L7.69556 17.7131C7.71433 18.225 8.13471 18.6302 8.64687 18.6302C9.15823 18.6302 9.57825 18.2262 9.59812 17.7153L9.79169 12.7408M4.37502 10.7135C3.22444 10.7135 2.29169 9.78079 2.29169 8.63021C2.29169 7.47962 3.22444 6.54688 4.37502 6.54688",
    stroke: "#6374FA",
    strokeWidth: 1.04167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58331 5.29169V11.9584",
    stroke: "#6374FA",
    strokeWidth: 1.04167,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.51a96525b5fcc453aa24482e0ed0feee.svg";
export { ForwardRef as ReactComponent };